import { Currencies } from '@constants/enums';

interface IValidateConversion {
  destinationCurrency: Currencies;
  destinationAmount: number;
}

interface UseValidateConversionResponse {
  validateUsdAmount: (props: IValidateConversion) => boolean;
}

const useValidateConversion = (): UseValidateConversionResponse => {
  const validateUsdAmount = ({
    destinationCurrency,
    destinationAmount,
  }: IValidateConversion) => {
    if (destinationCurrency === Currencies.USD && destinationAmount < 1) {
      return false;
    }
    return true;
  };

  return { validateUsdAmount };
};

export default useValidateConversion;
